const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
const API_KEY = process.env.NEXT_PUBLIC_API_KEY;

export function getApiBaseUrl(): string {
  if (!API_BASE_URL) {
    throw new Error(
      "NEXT_PUBLIC_API_BASE_URL is not defined. Add it to your .env.local file.",
    );
  }

  return API_BASE_URL.replace(/\/$/, "");
}

export function getApiKey(): string {
  if (!API_KEY) {
    throw new Error(
      "NEXT_PUBLIC_API_KEY is not defined. Add it to your .env.local file.",
    );
  }

  return API_KEY;
}
